import styled from 'styled-components';
import CardText from './CardText';

export const StyledCustomCard = styled.div`
  background: ${({ theme }) => theme.colors.background};
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  .default-type-title {
    color: ${({ theme }) => theme.colors.primaryText};
    font-size: 14px;
  }

  .default-type-array-title,
  .default-type-object-title,
  .default-type-boolean,
  .default-type-integer,
  .default-type-null,
  .default-type-number,
  .default-type-string {
    padding-left: 20px;
    padding-right: 20px;
  }

  .default-type-array-title,
  .default-type-object-title {
    margin-bottom: 15px;
  }
  .default-type-object-children {
    border-top: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
    padding-top: 15px;
    margin-bottom: 20px;
  }

  .default-type-boolean,
  .default-type-integer,
  .default-type-null,
  .default-type-number,
  .default-type-string {
    display: grid;
    grid-template-columns: 120px auto;
    gap: 8px;
    font-size: 14px;
    margin-bottom: 15px;
    &:last-child:not(:first-child) {
      margin-bottom: 0;
    }

    .default-type-boolean-title,
    .default-type-integer-title,
    .default-type-null-title,
    .default-type-number-title,
    .default-type-string-title {
      word-wrap: break-word;
      overflow-wrap: anywhere;
      font-weight: normal;
      color: ${({ theme }) => theme.colors.secondaryText};
    }
    .default-type-boolean-value,
    .default-type-integer-value,
    .default-type-null-value,
    .default-type-number-value,
    .default-type-string-value {
      word-wrap: break-word;
      overflow-wrap: anywhere;
      color: ${({ theme }) => theme.colors.primaryText};
    }
  }

  .default-type-object-title {
    .default-type-description {
      color: ${({ theme }) => theme.colors.secondaryText};
      font-size: 14px;
      padding-top: 4px;
    }
  }

  .default-type-root-header {
    padding: 16px;
    &.default-type-array-title,
    &.default-type-object-title {
      margin: 0;
    }
    .default-type-title-description-wrapper {
      line-height: 1;
      .default-type-title {
        padding: 0;
        color: ${({ theme }) => theme.colors.primaryText};
        display: block;
        font-weight: 800;
        text-transform: uppercase;
      }
    }
  }

  .default-type-root-sub-header {
    .default-type-title {
      padding: 0;
      color: ${({ theme }) => theme.colors.primaryText};
      display: block;
      font-weight: 800;
      text-transform: uppercase;
    }
  }

  .default-type-array {
    margin-bottom: 10px;
  }

  .default-type-array-children {
    .default-type-array-item {
      border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
      padding-top: 15px;
      padding-bottom: 15px;
      &:first-child {
        border-top: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }

  .default-type-string {
    span.default-type-string-value > audio {
      max-width: 250px;
    }
  }
`;

export const CustomCardHeader = styled.div`
  padding: 10px 16px;
`;

export const Title = styled(CardText).attrs({
  color: 'primaryText',
  'text-transform': 'uppercase',
})`
  font-size: 14px;
  font-weight: 800;
`;

export const Description = styled(CardText).attrs({
  color: 'secondaryText',
})`
  font-size: 10px;
`;
